import { AppContextProps } from "../AppContext";
import MessageDialogBase, { MessageDialogBaseProps } from "./MessageDialogBase";
import { GetDialogButtonColorByMeaning } from "./ColorMeaning";
import { DialogText } from "./DialogButtons";



export class MessageDialog {

  static Show(ctx: AppContextProps | null, message: string | React.ReactNode, title?: string,
    props?: Omit<MessageDialogBaseProps, 'open'>) {

    const dailog = ctx?.ShowDialog(MessageDialogBase, {

      colorMeaning: props?.colorMeaning,

      title: title,
      message: message,

      fullWidth: true,

      yesText: (props?.yesText == null ? DialogText.OK : props?.yesText),
      yesButtonProps: { variant: (title === undefined ? 'text' : 'contained'), color: GetDialogButtonColorByMeaning(props?.colorMeaning) as any },

      noButtonProps: { color: 'inherit' },

      cancelButtonProps: { color: 'inherit' },

      isDangerAction: (props?.colorMeaning === 'Danger' || props?.colorMeaning === 'Warning'),

      ...props,

      onDialogResult(e) {// 注意! 要放在 ...props 後面覆寫事件

        props?.onDialogResult?.(e);

        if (e.IsCancelClose !== true) {
          dailog?.destroy();
          return;
        }
      }

    })

    return dailog;


  }

}




